import { io } from 'socket.io-client';
import { SOCKET_URL, SOCKET_CONFIG } from '../config/api';

// La URL de tu backend (ya configurada en config/api.js)
const URL = SOCKET_URL;

// Creamos una única instancia del socket con configuración optimizada
export const socket = io(URL, SOCKET_CONFIG);
